/**
 * Jagad Jawa — Modul Data & Interaktivitas Tumpeng Tombak Rojo
 * Filosofi 5 Warna & Sesaji Panca Warna Tolak Bala
 */

(function (root) {
const TUMPENG_UBARAMPE = [
  {
    id: 1,
    nama: "Tumpeng Panca Warna (Kiblat Papat Limo Pancer)",
    posisi: "Piring Utama / Tengah",
    warna: "5 Warna (Putih, Merah, Kuning, Hitam, Hijau)",
    simbol: "Keseimbangan Jagad Gede & Jagad Cilik",
    deskripsi: "Lima tumpeng mini yang disusun mengelilingi pusat. Di puncak tumpeng tengah (hijau) ditancapkan pasak 'Tombak Rojo' berupa bilah lidi dengan cabai merah dan bawang putih tunggal sebagai senjata spiritual penolak bala ageng.",
    makna: "Melambangkan penyelarasan empat anasir semesta (tanah, api, air, udara) dan empat nafsu manusia (mutmainnah, amarah, supiyah, aluamah) yang dipimpin oleh sang Pancer (kesadaran jiwa raga).",
    icon: "fa-bowl-rice"
  },
  {
    id: 2,
    nama: "Kembang Setaman & Bawang Putih Tunggal",
    posisi: "Kiri Tengah (Wadah Anyaman Bambu)",
    warna: "Merah, Putih, Alami",
    simbol: "Keharuman Budi Pekerti & Daya Panyirna",
    deskripsi: "Bunga mawar merah, melati putih, dan kanthil beralas daun pisang segar, disandingkan dengan sebutir bawang putih lanang (tunggal).",
    makna: "Bawang putih tunggal melambangkan ketunggalan tekad dan perisai penangkal energi negatif. Kembang setaman melambangkan harapan agar tindak-tanduk manusia senantiasa menebar keharuman asma luhur.",
    icon: "fa-spa"
  },
  {
    id: 3,
    nama: "Kembang Panca Warna / Tujuh Rupa",
    posisi: "Kanan Atas (Mangkuk Kaca Bening)",
    warna: "Warni-warni Segar",
    simbol: "Sembah Bekti & Restu Para Leluhur",
    deskripsi: "Mangkuk kaca berisi air bening yang ditaburi aneka bunga segar: mawar merah, mawar merah muda, melati, kemboja, dan kenanga.",
    makna: "Air melambangkan sumber kehidupan murni (*tirta amerta*), sedangkan bunga-bungaan adalah simbol doa sembah bekti kepada Sang Maha Pencipta dan penghormatan tulus kepada leluhur cikal bakal.",
    icon: "fa-fan"
  },
  {
    id: 4,
    nama: "Telur Bebek, Koin Kuno Gobog, & Pala Kependem",
    posisi: "Kanan Tengah Atas (Wadah Anyaman Bambu)",
    warna: "Cokelat, Perunggu, Alami",
    simbol: "Wiji Dadi & Hasil Bumi Kasembadan",
    deskripsi: "Telur bebek/kampung berbintik utuh, uang kepeng/koin gobog kuno berlubang tengah, serta buah pala dan kemiri beralas daun pisang.",
    makna: "Telur melambangkan awal mula benih kehidupan (*wiji dadi*). Koin gobog kuno melambangkan sarana ijab kabul, bekal kebajikan, dan rezeki halal. Buah pala dan kemiri melambangkan kemakmuran hasil bumi nusantara.",
    icon: "fa-coins"
  },
  {
    id: 5,
    nama: "Rempah Dlingo Bengle & Bubur Putih (Tajin)",
    posisi: "Kanan Bawah (Anyaman Sirih & Mangkuk Kaca)",
    warna: "Cokelat Rempah & Putih Bersih",
    simbol: "Panulak Sawan & Kemurnian Pasrah",
    deskripsi: "Wadah anyaman beralas daun sirih berisi rempah tolak sawan (dlingo, bengle, cengkeh, dan tembakau), disandingkan dengan mangkuk bubur putih lembut.",
    makna: "Dlingo bengle secara tradisional dipercaya memancarkan aura tolak bala dari gangguan sawan dan energi panas jahat. Bubur putih melambangkan kepasrahan jiwa yang tulus (*sumarah*) marang takdir Gusti.",
    icon: "fa-mortar-pestle"
  },
  {
    id: 6,
    nama: "Wedang Kopi Pahit (Wedang Cemeng)",
    posisi: "Kiri Bawah (Cangkir Keramik Tanah)",
    warna: "Hitam Pekat",
    simbol: "Pait Getiring Panguripan & Eling Waspada",
    deskripsi: "Cangkir tanah liat berisi seduhan kopi tubruk hitam murni tanpa gula yang disajikan hangat.",
    makna: "Melambangkan kesiapan batin manusia untuk menelan pahit getirnya ujian hidup. Kopi pahit mengajarkan manusia agar selalu waspada (*eling lan waspada*), tidak terlena oleh buaian duniawi.",
    icon: "fa-mug-hot"
  },
  {
    id: 7,
    nama: "Wedang Teh Manis / Wedang Bening",
    posisi: "Kiri Atas (Cangkir Kaca Tampah)",
    warna: "Cokelat Kemerahan Jernih",
    simbol: "Legining Panguripan & Katentreman",
    deskripsi: "Cangkir kaca beralas daun pisang di atas tampah bambu kecil berisi teh tubruk wangi beraroma manis lembut.",
    makna: "Melambangkan harapan agar sesudah melewati pahitnya perjuangan hidup, akhir dari setiap langkah manusia senantiasa berbuah manis, tentram, harmonis, dan penuh berkah keselamatan (*rahayu wilujeng*).",
    icon: "fa-glass-water"
  }
];

const TUMPENG_WARNA = {
  putih: {
    nama: "Nasi Putih (Wetan / Timur)",
    warnaBadge: "bg-slate-100 text-slate-900 border-slate-300",
    bgCard: "from-slate-100/10 via-slate-200/5 to-transparent border-slate-400/40",
    arah: "Wetan (Timur)",
    nafsu: "Mutmainnah",
    sedulur: "Kakang Kawah (Air Ketuban)",
    unsur: "Hawa / Udara Bening",
    watak: "Kesucian, ketenangan batin, kejujuran, ketulusan budi pekerti, lan keteguhan iman.",
    filosofi: "Nasi putih ditempatkan di sebelah timur menghadap arah terbitnya fajar. Mengingatkan manusia bahwa hidup harus diawali dengan niat yang suci, nurani yang bersih, serta ketulusan tanpa pamrih dalam mengabdi kepada sesama.",
    bahan: "Beras putih pulen berkualitas terbaik, dimasak dang-dangan tradisional."
  },
  abang: {
    nama: "Nasi Merah (Kidul / Selatan)",
    warnaBadge: "bg-rose-500 text-white border-rose-400",
    bgCard: "from-rose-500/15 via-rose-600/5 to-transparent border-rose-500/50",
    arah: "Kidul (Selatan)",
    nafsu: "Amarah",
    sedulur: "Getih (Darah)",
    unsur: "Geni / Api",
    watak: "Keberanian, ketegasan, daya juang, semangat pantang mundur, lan pertahanan diri.",
    filosofi: "Nasi merah ditempatkan di sisi selatan, lambang energi api yang membakar kebatilan. Nafsu amarah tidak boleh dimatikan melainkan dikendalikan agar menjadi daya dorong membela kebenaran dan menaklukkan rintangan.",
    bahan: "Beras merah alami atau beras putih yang diwarnai sari alami cabe merah/angkak."
  },
  kuning: {
    nama: "Nasi Kuning (Kulon / Barat)",
    warnaBadge: "bg-amber-400 text-amber-950 border-amber-300",
    bgCard: "from-amber-500/15 via-amber-600/5 to-transparent border-amber-400/50",
    arah: "Kulon (Barat)",
    nafsu: "Supiyah",
    sedulur: "Puser (Tali Pusar)",
    unsur: "Banyu / Air & Kencana (Emas)",
    watak: "Kagum marang kaendahan, kemakmuran, kemuliaan hidup, rejeki lumintu, lan keluhuran drajat.",
    filosofi: "Nasi kuning di sisi barat menghadap matahari terbenam, simbol kematangan dan kelimpahan rezeki. Mengingatkan agar kemakmuran dan kehormatan tidak melahirkan kesombongan, melainkan jadi sarana berderma.",
    bahan: "Beras gurih beraroma rempah kunyit parut, serai, daun salam, dan santan kelapa."
  },
  cemeng: {
    nama: "Nasi Hitam / Cemeng (Lor / Utara)",
    warnaBadge: "bg-zinc-800 text-zinc-100 border-zinc-600",
    bgCard: "from-zinc-800/30 via-zinc-900/10 to-transparent border-zinc-600/50",
    arah: "Lor (Utara)",
    nafsu: "Aluamah",
    sedulur: "Adhi Ari-Ari (Plasenta)",
    unsur: "Bumi / Tanah / Siti",
    watak: "Kekuatan batin, keteguhan prinsip, daya tahan fisik, keteguhan hati, lan kelanggengan.",
    filosofi: "Nasi hitam diletakkan di arah utara, kutub ketenangan dan bumi pertiwi. Melambangkan pengekangan hawa nafsu kedagingan agar jiwa menjadi teguh dan tahan menghadapi segala cobaan zaman.",
    bahan: "Beras ketan hitam wulung murni yang dimasak lembut dengan aroma pandan wangi."
  },
  ijo: {
    nama: "Nasi Hijau — Tombak Rojo (Tengah / Pancer)",
    warnaBadge: "bg-emerald-600 text-white border-emerald-400",
    bgCard: "from-emerald-500/20 via-emerald-600/5 to-transparent border-emerald-400/60",
    arah: "Pancer (Pusat Semesta)",
    nafsu: "Manunggal / Kasedayan",
    sedulur: "Raga & Sukma Pribadi",
    unsur: "Hayat / Keseimbangan Kosmik",
    watak: "Penyelarasan segenap daya rohani, ketajaman mata batin, penolak bala ageng, lan katentreman sejati.",
    filosofi: "Nasi hijau berdiri megah di pusat keempat penjuru. Di puncaknya ditancapkan pasak 'Tombak Rojo' (cabai merah dan bawang putih tunggal). Inilah mahkota pusaka yang mengikat keempat arah agar manunggal dalam lindungan Gusti.",
    bahan: "Beras pulen beraroma perasan daun suji dan daun pandan wangi alami."
  }
};

function selectTumpengHotspot(index) {
  const item = TUMPENG_UBARAMPE.find(x => x.id === Number(index));
  if (!item) return;

  // Highlight hotspot buttons
  document.querySelectorAll('.tumpeng-hotspot-btn').forEach(btn => {
    if (Number(btn.dataset.hotspot) === item.id) {
      btn.classList.add('active', 'scale-110', 'ring-4', 'ring-prada');
    } else {
      btn.classList.remove('active', 'scale-110', 'ring-4', 'ring-prada');
    }
  });

  // Update Detail Card
  const elNum = document.getElementById('tumpengDetailNum');
  const elTitle = document.getElementById('tumpengDetailTitle');
  const elPos = document.getElementById('tumpengDetailPos');
  const elSimbol = document.getElementById('tumpengDetailSimbol');
  const elDesc = document.getElementById('tumpengDetailDesc');
  const elMakna = document.getElementById('tumpengDetailMakna');
  const elWarna = document.getElementById('tumpengDetailWarna');

  if (elNum) elNum.textContent = `0${item.id}`;
  if (elTitle) elTitle.textContent = item.nama;
  if (elPos) elPos.textContent = item.posisi;
  if (elSimbol) elSimbol.textContent = item.simbol;
  if (elDesc) elDesc.textContent = item.deskripsi;
  if (elMakna) elMakna.textContent = item.makna;
  if (elWarna) elWarna.textContent = item.warna;

  // Flash highlight effect
  const card = document.getElementById('tumpengDetailCard');
  if (card) {
    card.classList.add('ring-2', 'ring-prada');
    setTimeout(() => card.classList.remove('ring-2', 'ring-prada'), 400);
  }
}

function selectTumpengWarna(key) {
  const data = TUMPENG_WARNA[key];
  if (!data) return;

  document.querySelectorAll('.tumpeng-warna-btn').forEach(btn => {
    if (btn.dataset.warna === key) {
      btn.classList.add('border-prada', 'bg-prada/20', 'text-prada-light');
    } else {
      btn.classList.remove('border-prada', 'bg-prada/20', 'text-prada-light');
    }
  });

  const elTitle = document.getElementById('tumpengWarnaTitle');
  const elBadge = document.getElementById('tumpengWarnaBadge');
  const elArah = document.getElementById('tumpengWarnaArah');
  const elNafsu = document.getElementById('tumpengWarnaNafsu');
  const elSedulur = document.getElementById('tumpengWarnaSedulur');
  const elUnsur = document.getElementById('tumpengWarnaUnsur');
  const elWatak = document.getElementById('tumpengWarnaWatak');
  const elFilosofi = document.getElementById('tumpengWarnaFilosofi');
  const elBahan = document.getElementById('tumpengWarnaBahan');
  const card = document.getElementById('tumpengWarnaCard');

  if (elTitle) elTitle.textContent = data.nama;
  if (elBadge) {
    elBadge.className = `px-3 py-1 rounded-full text-[11px] font-bold border ${data.warnaBadge}`;
    elBadge.textContent = data.arah;
  }
  if (elArah) elArah.textContent = data.arah;
  if (elNafsu) elNafsu.textContent = data.nafsu;
  if (elSedulur) elSedulur.textContent = data.sedulur;
  if (elUnsur) elUnsur.textContent = data.unsur;
  if (elWatak) elWatak.textContent = data.watak;
  if (elFilosofi) elFilosofi.textContent = data.filosofi;
  if (elBahan) elBahan.textContent = data.bahan;

  if (card) {
    card.className = `p-6 rounded-2xl border bg-gradient-to-br transition-all duration-300 shadow-xl ${data.bgCard}`;
  }
}

// Global Browser Window & CommonJS Exports
root.TUMPENG_UBARAMPE = TUMPENG_UBARAMPE;
root.TUMPENG_WARNA = TUMPENG_WARNA;
root.selectTumpengHotspot = selectTumpengHotspot;
root.selectTumpengWarna = selectTumpengWarna;

// Auto-init when tab switches to tumpeng
if (typeof window !== 'undefined') {
  window.addEventListener('tab-switched', (e) => {
    if (e.detail && e.detail.tabId === 'tumpeng') {
      selectTumpengHotspot(1);
      selectTumpengWarna('ijo');
    }
  });
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    TUMPENG_UBARAMPE,
    TUMPENG_WARNA,
    selectTumpengHotspot,
    selectTumpengWarna
  };
}
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this));

const _gTumpeng = typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : {});
export const TUMPENG_UBARAMPE = _gTumpeng.TUMPENG_UBARAMPE;
export const TUMPENG_WARNA = _gTumpeng.TUMPENG_WARNA;
export const selectTumpengHotspot = _gTumpeng.selectTumpengHotspot;
export const selectTumpengWarna = _gTumpeng.selectTumpengWarna;

export default {
  TUMPENG_UBARAMPE: _gTumpeng.TUMPENG_UBARAMPE,
  TUMPENG_WARNA: _gTumpeng.TUMPENG_WARNA,
  selectTumpengHotspot: _gTumpeng.selectTumpengHotspot,
  selectTumpengWarna: _gTumpeng.selectTumpengWarna
};

